module.exports = __webpack_public_path__ + "img/history-bg-1.93f3a16c.png";